import { createResource } from '../utils/resource'

const companyVehicleStore = createResource('companyVehicle', {})

export default companyVehicleStore
